<template>
  <v-container v-if="!isMobile">
    <nav>
      <v-app-bar app height="80">
        <v-toolbar-title>
          <v-breadcrumbs :items="items" large></v-breadcrumbs>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="mr-1">
          <v-select
            height="42"
            :items="boardName"
            value="boardName"
            label="Board Name"
            v-model="boardItem"
            @change="updateBoard"
            :item-text="
              (boardName) => {
                return boardName.boardName;
              }
            "
            prepend-inner-icon="mdi-integrated-circuit-chip"
            solo
            hide-details
            outlined
            dense
          ></v-select>
        </div>
        <v-md-date-range-picker :presets="presets" opens="right" @change="updateData" class="mr-2">
          <v-card class="pa-2" slot="input" style="outline:1px solid grey;">
            <v-icon color="red darken-2"> mdi-clock-outline </v-icon> <span style="font-size: 15px;">{{ formatDate($store.state.dateTime1) }} - {{ formatDate($store.state.dateTime2) }}</span>
          </v-card>
        </v-md-date-range-picker>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn :loading="loading5" :disabled="loading5" :color="!timer ? 'red' : 'green'" :class="!timer ? 'ma-1 white--text' : 'ma-1 white--text'" @click="(timer = !timer), (loader = 'loading5')" fab small v-bind="attrs" v-on="on">
              <v-icon dark>
                {{ !timer ? "mdi-play" : "mdi-pause" }}
              </v-icon>
            </v-btn>
          </template>
          <span> {{ !timer ? "Enable Auto Refresh Page" : "Disable Auto Refresh Page" }}</span>
        </v-tooltip>
      </v-app-bar>
    </nav>
    <div>
      <p style="font-size:14px;text-align:center;" v-if="board.length == 0">
        No Data
      </p>
      <p style="font-size:14px;text-align:center;" v-else>
        <v-icon v-if="lastOnline < 6" color="green">mdi-circle</v-icon>
        <v-icon v-else>mdi-circle</v-icon>
        Last update was {{ lastUpdate.substring(2) }} ago
      </p>
    </div>
    <v-row>
      <v-col>
        <v-row dense>
          <v-col>
            <v-card class="mx-auto text-center" color="white" dark max-width="200" max-height="100" :to="{ name: 'Meter' }">
              <v-card-text v-if="unixConvert($store.state.dateTime1) > unixConvert(meter[0].updatedAt)">
                <div style="font-size:12px;color:black;">
                  Meter Reading
                </div>
                <div style="font-size:18px;color:black;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:black;" v-else>
                  {{ totalMeter }}
                </div>
              </v-card-text>
              <v-card-text v-else>
                <div style="font-size:12px;color:black;">
                  Meter Reading
                </div>
                <div style="font-size:18px;color:black;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:14px;color:red;" v-else>
                  {{ totalMeter }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="mx-auto text-center" color="red lighten-1" dark max-width="200" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:black;">
                  Phase 1 Bill
                </div>
                <div style="font-size:18px;color:black;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:black;" v-else><span>RM</span> {{ totalPhase1 }}</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="mx-auto text-center" color="yellow darken-1" dark max-width="200" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:black;">
                  Phase 2 Bill
                </div>
                <div style="font-size:18px;color:black;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:black;" v-else><span style="color:black;">RM</span> {{ totalPhase2 }}</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="mx-auto text-center" color="blue lighten-1" dark max-width="200" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:black;">
                  Phase 3 Bill
                </div>
                <div style="font-size:18px;color:black;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:black;" v-else><span>RM</span> {{ totalPhase3 }}</div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col>
            <v-card class="mx-auto text-center" color="white" dark max-width="200" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:black;">
                  Current Bill
                </div>
                <div style="font-size:18px;color:black;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:black;" v-else><span>RM</span> {{ totalNeedPay }}</div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-card class="pt-5 pb-5 mt-7">
      <v-row>
        <v-col style="padding:0; margin:0;">
          <p class="mx-auto text-center" style="color:grey;">Phase 1</p>
        </v-col>
      </v-row>

      <v-container>
        <v-row>
          <v-col v-if="loading">
            <v-container style="height: 200px;" v-if="loading">
              <v-row class="fill-height" align-content="center" justify="center">
                <v-col class="text-subtitle-1 text-center" cols="12">
                  Getting your chart
                </v-col>
                <v-col cols="6">
                  <v-progress-linear color="blue" indeterminate rounded height="6"></v-progress-linear>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col v-else>
            <v-row class="fill-height" align-content="center" justify="center">
              <v-col class="text-subtitle-1 text-center" cols="12" v-if="board.length == 0">
                No Data
              </v-col>
              <v-col class="text-subtitle-1 text-center" cols="12" v-else>
                <apexchart height="260" type="line" :options="voltageP1Chart" :series="voltageP1Series"></apexchart>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-col cols="12" style="padding:0; margin:0;">
              <p class="mx-auto text-center" style="font-size:12px">Phase-1</p>
            </v-col>

            <v-card class="mx-auto text-center mb-1" color="red lighten-1" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:#404040;">
                  From Beginning
                </div>
                <div style="font-size:18px;color:#404040;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:#404040;" v-else>{{ kw1[0].toFixed(0) }}<span style="font-size:10px">kW</span></div>
              </v-card-text>
            </v-card>

            <v-card class="mx-auto text-center" color="red lighten-1" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:#404040;">
                  Query Period Total:
                </div>
                <div style="font-size:18px;color:#404040;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:#404040;" v-else>{{ Math.abs(kw1[0] - kw1.slice(-1)[0]).toFixed(2) }}<span style="font-size:10px">kW</span></div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col>
            <v-col cols="12" style="padding:0; margin:0;">
              <p class="mx-auto text-center" style="font-size:12px">Voltage</p>
            </v-col>

            <v-card class="mx-auto text-center mb-1" color="red lighten-1" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:#404040;">
                  Recently
                </div>
                <div style="font-size:18px;color:#404040;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:#404040;" v-else>{{ volt1[0].toFixed(2) }}<span style="font-size:10px">V</span></div>
              </v-card-text>
            </v-card>

            <v-card class="mx-auto text-center" color="red lighten-1" dark max-width="150" max-height="100">
              <div style="font-size:12px;color:#404040;">
                Peak
              </div>
              <div style="font-size:14.5px;color:#404040;" v-if="board.length == 0">
                No Data
              </div>
              <div style="font-size:14.5px;color:#404040;" v-else>{{ Math.max(...volt1) }}<span style="font-size:10px">V</span></div>
            </v-card>
            <v-card class="mx-auto text-center" color="red lighten-3" dark max-width="150" max-height="100">
              <div style="font-size:12px;color:#404040;">
                Min
              </div>
              <div style="font-size:14.5px;color:#404040;" v-if="board.length == 0">
                No Data
              </div>
              <div style="font-size:14.5px;color:#404040;" v-else>{{ Math.min(...volt1) }}<span style="font-size:10px">V</span></div>
            </v-card>
          </v-col>

          <v-col>
            <v-col cols="12" style="padding:0; margin:0;">
              <p class="mx-auto text-center" style="font-size:12px;color:#404040;">Current</p>
            </v-col>

            <v-card class="mx-auto text-center mb-1" color="red lighten-1" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:#404040;">
                  Recently
                </div>
                <div style="font-size:18px;color:#404040;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:#404040;" v-else>{{ amp1[0] }}<span style="font-size:10px">A</span></div>
              </v-card-text>
            </v-card>

            <v-card class="mx-auto text-center" color="red lighten-1" dark max-width="150" max-height="100">
              <div style="font-size:12px;color:#404040;">
                Peak
              </div>
              <div style="font-size:14.5px;color:#404040;" v-if="board.length == 0">
                No Data
              </div>
              <div style="font-size:14.5px;color:#404040;" v-else>{{ Math.max(...amp1) }}<span style="font-size:10px">A</span></div>
            </v-card>

            <v-card class="mx-auto text-center" color="red lighten-3" dark max-width="150" max-height="100">
              <div style="font-size:12px;color:#404040;">
                Min
              </div>
              <div style="font-size:14.5px;color:#404040;" v-if="board.length == 0">
                No Data
              </div>
              <div style="font-size:14.5px;color:#404040;" v-else>{{ Math.min(...amp1) }}<span style="font-size:10px">A</span></div>
            </v-card>
          </v-col>

          <v-col>
            <v-col cols="12" style="padding:0; margin:0;">
              <p class="mx-auto text-center" style="font-size:12px">P<span style="font-size:8px">F</span></p>
            </v-col>

            <v-card class="mx-auto text-center mb-1" color="white" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:#404040;">
                  Recently
                </div>
                <div style="font-size:18px;color:#404040;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:#404040;" v-else>
                  {{ pf1[0] }}
                </div>
              </v-card-text>
            </v-card>

            <v-card class="mx-auto text-center" color="white" dark max-width="150" max-height="100">
              <div style="font-size:12px;color:#404040;">
                Peak
              </div>
              <div style="font-size:14.5px;color:#404040;" v-if="board.length == 0">
                No Data
              </div>
              <div style="font-size:14.5px;color:#404040;" v-else>
                {{ Math.max(...pf1) }}
              </div>
            </v-card>

            <v-card class="mx-auto text-center" color="white" dark max-width="150" max-height="100">
              <div style="font-size:12px;color:#404040;">
                Min
              </div>
              <div style="font-size:14.5px;#404040;" v-if="board.length == 0">
                No Data
              </div>
              <div style="font-size:14.5p;color:#404040;" v-else>
                {{ Math.min(...pf1) }}
              </div>
            </v-card>
          </v-col>

          <v-col>
            <v-col cols="12" style="padding:0; margin:0;">
              <p class="mx-auto text-center" style="font-size:12px">Swell / Sag</p>
            </v-col>

            <v-card class="mx-auto text-center mb-1" color="white" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="color:#404040;font-size:12px">
                  Swell occurrence
                </div>
                <div style="color:#404040;font-size:18px" v-if="board.length == 0">
                  No Data
                </div>
                <div style="color:#404040;font-size:18px" v-else>
                  {{ event1.length }}
                </div>
              </v-card-text>
            </v-card>

            <v-card class="mx-auto text-center" color="white" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:#404040;">
                  Sag occurrence
                </div>
                <div style="font-size:18px;color:#404040;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:#404040;" v-else>
                  {{ event2.length }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <!-- yelllllloooooooow -->
    <v-card class="pt-5 pb-5 mt-7">
      <v-row>
        <v-col style="padding:0; margin:0;">
          <p class="mx-auto text-center" style="color:grey;">Phase 2</p>
        </v-col>
      </v-row>

      <v-container>
        <v-row>
          <v-col v-if="loading">
            <v-container style="height: 200px;" v-if="loading">
              <v-row class="fill-height" align-content="center" justify="center">
                <v-col class="text-subtitle-1 text-center" cols="12">
                  Getting your chart
                </v-col>
                <v-col cols="6">
                  <v-progress-linear color="blue" indeterminate rounded height="6"></v-progress-linear>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col v-else>
            <v-row class="fill-height" align-content="center" justify="center">
              <v-col class="text-subtitle-1 text-center" cols="12" v-if="board.length == 0">
                No Data
              </v-col>
              <v-col class="text-subtitle-1 text-center" cols="12" v-else>
                <apexchart height="260" type="line" :options="voltageP2Chart" :series="voltageP2Series"></apexchart>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- <v-row>
          <v-col v-if="board.length == 0">
            <v-row class="fill-height" align-content="center" justify="center">
              <v-col class="text-subtitle-1 text-center" cols="12">
                No Data
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" v-else>
            <v-container style="height: 200px;" v-if="loading">
              <v-row class="fill-height" align-content="center" justify="center">
                <v-col class="text-subtitle-1 text-center" cols="12">
                  Getting your chart
                </v-col>
                <v-col cols="6">
                  <v-progress-linear color="blue" indeterminate rounded height="6"></v-progress-linear>
                </v-col>
              </v-row>
            </v-container>
            <apexchart height="260" type="line" :options="voltageP2Chart" :series="voltageP2Series" v-else></apexchart>
          </v-col>
        </v-row> -->

        <v-row>
          <v-col>
            <v-col cols="12" style="padding:0; margin:0;">
              <p class="mx-auto text-center" style="font-size:12px">Phase-1</p>
            </v-col>

            <v-card class="mx-auto text-center mb-1" color="yellow darken-1" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:#404040;">
                  From Beginning
                </div>
                <div style="font-size:18px;color:#404040;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:#404040;" v-else>{{ kw2[0].toFixed(0) }}<span style="font-size:10px">kW</span></div>
              </v-card-text>
            </v-card>

            <v-card class="mx-auto text-center" color="yellow darken-1" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:#404040;">
                  Query Period Total:
                </div>
                <div style="font-size:18px;color:#404040;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:#404040;" v-else>{{ Math.abs(kw2[0] - kw2.slice(-1)[0]).toFixed(2) }}<span style="font-size:10px">kW</span></div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col>
            <v-col cols="12" style="padding:0; margin:0;">
              <p class="mx-auto text-center" style="font-size:12px">Voltage</p>
            </v-col>

            <v-card class="mx-auto text-center mb-1" color="yellow darken-1" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:#404040;">
                  Recently
                </div>
                <div style="font-size:18px;color:#404040;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:#404040;" v-else>{{ volt2[0].toFixed(2) }}<span style="font-size:10px">V</span></div>
              </v-card-text>
            </v-card>

            <v-card class="mx-auto text-center" color="yellow darken-1" dark max-width="150" max-height="100">
              <div style="font-size:12px;color:#404040;">
                Peak
              </div>
              <div style="font-size:14.5px;color:#404040;" v-if="board.length == 0">
                No Data
              </div>
              <div style="font-size:14.5px;color:#404040;" v-else>{{ Math.max(...volt2) }}<span style="font-size:10px">V</span></div>
            </v-card>
            <v-card class="mx-auto text-center" color="yellow lighten-3" dark max-width="150" max-height="100">
              <div style="font-size:12px;color:#404040;">
                Min
              </div>
              <div style="font-size:14.5px;color:#404040;" v-if="board.length == 0">
                No Data
              </div>
              <div style="font-size:14.5px;color:#404040;" v-else>{{ Math.min(...volt2) }}<span style="font-size:10px">V</span></div>
            </v-card>
          </v-col>

          <v-col>
            <v-col cols="12" style="padding:0; margin:0;">
              <p class="mx-auto text-center" style="font-size:12px">Current</p>
            </v-col>

            <v-card class="mx-auto text-center mb-1" color="yellow darken-1" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:#404040;">
                  Recently
                </div>
                <div style="font-size:18px;color:#404040;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:#404040;" v-else>{{ amp2[0] }}<span style="font-size:10px">A</span></div>
              </v-card-text>
            </v-card>

            <v-card class="mx-auto text-center" color="yellow darken-1" dark max-width="150" max-height="100">
              <div style="font-size:12px;color:#404040;">
                Peak
              </div>
              <div style="font-size:14.5px;color:#404040;" v-if="board.length == 0">
                No Data
              </div>
              <div style="font-size:14.5px;color:#404040;" v-else>{{ Math.max(...amp2) }}<span style="font-size:10px">A</span></div>
            </v-card>

            <v-card class="mx-auto text-center" color="yellow lighten-3" dark max-width="150" max-height="100">
              <div style="font-size:12px;color:#404040;">
                Min
              </div>
              <div style="font-size:14.5px;color:#404040;" v-if="board.length == 0">
                No Data
              </div>
              <div style="font-size:14.5px;color:#404040;" v-else>{{ Math.min(...amp2) }}<span style="font-size:10px">A</span></div>
            </v-card>
          </v-col>

          <v-col>
            <v-col cols="12" style="padding:0; margin:0;">
              <p class="mx-auto text-center" style="font-size:12px">P<span style="font-size:8px">F</span></p>
            </v-col>

            <v-card class="mx-auto text-center mb-1" color="white" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:#404040;">
                  Recently
                </div>
                <div style="font-size:18px;color:#404040;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:#404040;" v-else>
                  {{ pf2[0] }}
                </div>
              </v-card-text>
            </v-card>

            <v-card class="mx-auto text-center" color="white" dark max-width="150" max-height="100">
              <div style="font-size:12px;color:#404040;">
                Peak
              </div>
              <div style="font-size:14.5px;color:#404040;" v-if="board.length == 0">
                No Data
              </div>
              <div style="font-size:14.5px;color:#404040;" v-else>
                {{ Math.max(...pf2) }}
              </div>
            </v-card>

            <v-card class="mx-auto text-center" color="white" dark max-width="150" max-height="100">
              <div style="font-size:12px;color:#404040;">
                Min
              </div>
              <div style="font-size:14.5px;color:#404040;" v-if="board.length == 0">
                No Data
              </div>
              <div style="font-size:14.5p;color:#404040;" v-else>
                {{ Math.min(...pf2) }}
              </div>
            </v-card>
          </v-col>

          <v-col>
            <v-col cols="12" style="padding:0; margin:0;">
              <p class="mx-auto text-center" style="font-size:12px">Swell / Sag</p>
            </v-col>

            <v-card class="mx-auto text-center mb-1" color="white" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="color:#404040;font-size:12px">
                  Swell occurrence
                </div>
                <div style="color:#404040;font-size:18px" v-if="board.length == 0">
                  No Data
                </div>
                <div style="color:#404040;font-size:18px" v-else>
                  {{ event3.length }}
                </div>
              </v-card-text>
            </v-card>

            <v-card class="mx-auto text-center" color="white" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:#404040;">
                  Sag occurrence
                </div>
                <div style="font-size:18px;color:#404040;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:#404040;" v-else>
                  {{ event4.length }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <!-- blue -->
    <v-card class="pt-5 pb-5 mt-7">
      <v-row>
        <v-col style="padding:0; margin:0;">
          <p class="mx-auto text-center" style="color:grey;">Phase 3</p>
        </v-col>
      </v-row>

      <v-container>
        <v-row>
          <v-col v-if="loading">
            <v-container style="height: 200px;" v-if="loading">
              <v-row class="fill-height" align-content="center" justify="center">
                <v-col class="text-subtitle-1 text-center" cols="12">
                  Getting your chart
                </v-col>
                <v-col cols="6">
                  <v-progress-linear color="blue" indeterminate rounded height="6"></v-progress-linear>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col v-else>
            <v-row class="fill-height" align-content="center" justify="center">
              <v-col class="text-subtitle-1 text-center" cols="12" v-if="board.length == 0">
                No Data
              </v-col>
              <v-col class="text-subtitle-1 text-center" cols="12" v-else>
                <apexchart height="260" type="line" :options="voltageP3Chart" :series="voltageP3Series"></apexchart>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <!-- 
        <v-row>
          <v-col v-if="board.length == 0">
            <v-row class="fill-height" align-content="center" justify="center">
              <v-col class="text-subtitle-1 text-center" cols="12">
                No Data
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" v-else>
            <v-container style="height: 200px;" v-if="loading">
              <v-row class="fill-height" align-content="center" justify="center">
                <v-col class="text-subtitle-1 text-center" cols="12">
                  Getting your chart
                </v-col>
                <v-col cols="6">
                  <v-progress-linear color="blue" indeterminate rounded height="6"></v-progress-linear>
                </v-col>
              </v-row>
            </v-container>
            <apexchart height="260" type="line" :options="voltageP3Chart" :series="voltageP3Series" v-else></apexchart>
          </v-col>
        </v-row> -->

        <v-row>
          <v-col>
            <v-col cols="12" style="padding:0; margin:0;">
              <p class="mx-auto text-center" style="font-size:12px">Phase-1</p>
            </v-col>

            <v-card class="mx-auto text-center mb-1" color="blue lighten-1" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:#404040;">
                  From Beginning
                </div>
                <div style="font-size:18px;color:#404040;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px; color:#404040;" v-else>{{ kw3[0].toFixed(0) }}<span style="font-size:10px">kW</span></div>
              </v-card-text>
            </v-card>

            <v-card class="mx-auto text-center" color="blue lighten-1" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:#404040;">
                  Query Period Total:
                </div>
                <div style="font-size:18px;color:#404040;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:#404040;" v-else>{{ Math.abs(kw3[0] - kw3.slice(-1)[0]).toFixed(2) }}<span style="font-size:10px">kW</span></div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col>
            <v-col cols="12" style="padding:0; margin:0;">
              <p class="mx-auto text-center" style="font-size:12px">Voltage</p>
            </v-col>

            <v-card class="mx-auto text-center mb-1" color="blue lighten-1" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:#404040;">
                  Recently
                </div>
                <div style="font-size:18px;color:#404040;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:#404040;" v-else>{{ volt3[0].toFixed(2) }}<span style="font-size:10px">V</span></div>
              </v-card-text>
            </v-card>

            <v-card class="mx-auto text-center" color="blue lighten-1" dark max-width="150" max-height="100">
              <div style="font-size:12px;color:#404040;">
                Peak
              </div>
              <div style="font-size:14.5px;color:#404040;" v-if="board.length == 0">
                No Data
              </div>
              <div style="font-size:14.5px;color:#404040;" v-else>{{ Math.max(...volt3) }}<span style="font-size:10px">V</span></div>
            </v-card>
            <v-card class="mx-auto text-center" color="blue lighten-4" dark max-width="150" max-height="100">
              <div style="font-size:12px;color:#404040;">
                Min
              </div>
              <div style="font-size:14.5px;color:#404040;" v-if="board.length == 0">
                No Data
              </div>
              <div style="font-size:14.5px;color:#404040;" v-else>{{ Math.min(...volt3) }}<span style="font-size:10px">V</span></div>
            </v-card>
          </v-col>

          <v-col>
            <v-col cols="12" style="padding:0; margin:0;">
              <p class="mx-auto text-center" style="font-size:12px">Current</p>
            </v-col>

            <v-card class="mx-auto text-center mb-1" color="blue lighten-1" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:#404040;">
                  Recently
                </div>
                <div style="font-size:18px;color:#404040;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:#404040;" v-else>{{ amp3[0] }}<span style="font-size:10px">A</span></div>
              </v-card-text>
            </v-card>

            <v-card class="mx-auto text-center" color="blue lighten-1" dark max-width="150" max-height="100">
              <div style="font-size:12px;color:#404040;">
                Peak
              </div>
              <div style="font-size:14.5px;color:#404040;" v-if="board.length == 0">
                No Data
              </div>
              <div style="font-size:14.5px;color:#404040;" v-else>{{ Math.max(...amp3) }}<span style="font-size:10px">A</span></div>
            </v-card>

            <v-card class="mx-auto text-center" color="blue lighten-4" dark max-width="150" max-height="100">
              <div style="font-size:12px;color:#404040;">
                Min
              </div>
              <div style="font-size:14.5px;color:#404040;" v-if="board.length == 0">
                No Data
              </div>
              <div style="font-size:14.5px;color:#404040;" v-else>{{ Math.min(...amp3) }}<span style="font-size:10px">A</span></div>
            </v-card>
          </v-col>

          <v-col>
            <v-col cols="12" style="padding:0; margin:0;">
              <p class="mx-auto text-center" style="font-size:12px">P<span style="font-size:8px">F</span></p>
            </v-col>

            <v-card class="mx-auto text-center mb-1" color="white" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:#404040;">
                  Recently
                </div>
                <div style="font-size:18px;color:#404040;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:#404040;" v-else>
                  {{ pf3[0] }}
                </div>
              </v-card-text>
            </v-card>

            <v-card class="mx-auto text-center" color="white" dark max-width="150" max-height="100">
              <div style="font-size:12px;color:#404040;">
                Peak
              </div>
              <div style="font-size:14.5px;color:#404040;" v-if="board.length == 0">
                No Data
              </div>
              <div style="font-size:14.5px;color:#404040;" v-else>
                {{ Math.max(...pf3) }}
              </div>
            </v-card>

            <v-card class="mx-auto text-center" color="white" dark max-width="150" max-height="100">
              <div style="font-size:12px;color:#404040;">
                Min
              </div>
              <div style="font-size:14.5px;color:#404040;" v-if="board.length == 0">
                No Data
              </div>
              <div style="font-size:14.5p;color:#404040;" v-else>
                {{ Math.min(...pf3) }}
              </div>
            </v-card>
          </v-col>

          <v-col>
            <v-col cols="12" style="padding:0; margin:0;">
              <p class="mx-auto text-center" style="font-size:12px">Swell / Sag</p>
            </v-col>

            <v-card class="mx-auto text-center mb-1" color="white" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="color:black;font-size:12px">
                  Swell occurrence
                </div>
                <div style="color:black;font-size:18px" v-if="board.length == 0">
                  No Data
                </div>
                <div style="color:black;font-size:18px" v-else>
                  {{ event5.length }}
                </div>
              </v-card-text>
            </v-card>

            <v-card class="mx-auto text-center" color="white" dark max-width="150" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:black;">
                  Sag occurrence
                </div>
                <div style="font-size:18px;color:black;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:black;" v-else>
                  {{ event6.length }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-container>

  <div v-else>
    <div class="mt-5 pa-1" justify="center" align="center">
      <div class="pa-1">
        <v-select
          :items="boardName"
          value="boardName"
          label="Board Name"
          v-model="boardItem"
          @change="updateBoard"
          :item-text="
            (boardName) => {
              return boardName.boardName;
            }
          "
          prepend-inner-icon="mdi-integrated-circuit-chip"
          solo
          hide-details
          style="font-size: 12px;"
        ></v-select>
      </div>
      <div class="pa-1">
        <v-card style="text-align:left; display:flex; justify-content:space-between;">
          <v-md-date-range-picker :presets="presets" opens="left" @change="updateData">
            <v-card class="pa-3" slot="input" flat>
              <v-icon color="red darken-2"> mdi-clock-outline </v-icon><span style="font-size: 12px; margin-left: 5px;">{{ formatDate($store.state.dateTime1) }} - </span><span style="font-size: 12px;"> {{ formatDate($store.state.dateTime2) }}</span>
            </v-card>
          </v-md-date-range-picker>
        </v-card>
      </div>
    </div>

    <div class="pa-2 mt-5">
      <v-card class="mx-auto text-center" color="white" dark max-height="130" :to="{ name: 'Meter' }">
        <v-card-text v-if="unixConvert($store.state.dateTime1) > unixConvert(meter[0].updatedAt)">
          <div style="font-size:10px;color:black;">
            Meter Reading
          </div>
          <div style="font-size:12px;color:black;" v-if="board.length == 0">
            No Data
          </div>
          <div style="font-size:12px;color:black;" v-else>
            {{ totalMeter }}
          </div>
        </v-card-text>
        <v-card-text v-else>
          <div style="font-size:10px;color:black;">
            Meter Reading
          </div>
          <div style="font-size:10px;color:black;" v-if="board.length == 0">
            No Data
          </div>
          <div style="font-size:10px;color:red;" v-else>
            {{ totalMeter }}
          </div>
        </v-card-text>
      </v-card>

      <div>
        <v-row>
          <v-col>
            <v-card class="mx-auto text-center" color="red" dark max-height="100">
              <v-card-text>
                <div style="font-size:10px;color:black;">
                  Phase 1 Bill
                </div>
                <div style="font-size:12px;color:black;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:12px;color:black;" v-else><span>RM</span> {{ totalPhase1 }}</div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col>
            <v-card class="mx-auto text-center" color="yellow" dark max-height="100">
              <v-card-text>
                <div style="font-size:10px;color:black;">
                  Phase 2 Bill
                </div>
                <div style="font-size:12px;color:black;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:12px;color:black;" v-else><span style="color:black;">RM</span> {{ totalPhase2 }}</div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col>
            <v-card class="mx-auto text-center" color="blue" dark max-height="100">
              <v-card-text>
                <div style="font-size:10px;color:black;">
                  Phase 3 Bill
                </div>
                <div style="font-size:12px;color:black;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:12px;color:black;" v-else><span>RM</span> {{ totalPhase3 }}</div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <v-card class="mx-auto text-center" color="white" dark max-height="100">
        <v-card-text>
          <div style="font-size:10px;color:black;">
            Current Bill
          </div>
          <div style="font-size:12px;color:black;" v-if="board.length == 0">
            No Data
          </div>
          <div style="font-size:12px;color:black;" v-else><span>RM</span> {{ totalNeedPay }}</div>
        </v-card-text>
      </v-card>
    </div>

    <v-container>
      <div v-if="loading">
        <v-container style="height: 200px;">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="text-subtitle-1 text-center" cols="12">
              <span style="font-size:12px">Getting your chart</span>
            </v-col>
            <v-col cols="6">
              <v-progress-linear color="blue" indeterminate rounded height="6"></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div v-else>
        <div v-if="board.length == 0">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="text-subtitle-1 text-center" cols="12">
              No Data
            </v-col>
          </v-row>
        </div>

        <div v-else>
          <v-card class="pa-1 pt-5 pb-10">
            <h4 class="mx-auto text-center mb-5" style="color:grey;">Phase 1</h4>
            <apexchart type="line" :options="voltageP1ChartMobile" :series="voltageP1Series"></apexchart>

            <div class="mt-3 pa-1">
              <div>
                <p class="mx-auto text-center" style="font-size:11px; padding:0; margin:0">Phase-1</p>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="red" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:#333;">
                          From Beginning
                        </div>
                        <div style="font-size:12px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12px;color:#333;" v-else>{{ kw1[0].toFixed(0) }}<span style="font-size:10px">kW</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="mx-auto text-center" color="red" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:#333;">
                          Query Period Total:
                        </div>
                        <div style="font-size:12px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12px;color:#333;" v-else>{{ Math.abs(kw1[0] - kw1.slice(-1)[0]).toFixed(2) }}<span style="font-size:10px">kW</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div class="mt-4">
                <p class="mx-auto text-center" style="font-size:11px; padding:0; margin:0">Voltage</p>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="red" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:#333;">
                          Recently
                        </div>
                        <div style="font-size:12px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12px;color:#333;" v-else>{{ volt1[0].toFixed(2) }}<span style="font-size:10px">V</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="red" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:#333;">
                          Peak
                        </div>
                        <div style="font-size:12.5px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12.5px;color:#333;" v-else>{{ Math.max(...volt1) }}<span style="font-size:10px">V</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="mx-auto text-center" color="red lighten-2" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:#333;">
                          Min
                        </div>
                        <div style="font-size:12.5px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12.5px;color:#333;" v-else>{{ Math.min(...volt1) }}<span style="font-size:10px">V</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div class="mt-4">
                <p class="mx-auto text-center" style="font-size:11px; padding:0; margin:0">Current</p>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="red" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:#333;">
                          Recently
                        </div>
                        <div style="font-size:12px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12px;color:#333;" v-else>{{ amp1[0] }}<span style="font-size:10px;color:#333;">A</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="red" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:#333;">
                          Peak
                        </div>
                        <div style="font-size:12.5px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12.5px;color:#333;" v-else>{{ Math.max(...amp1) }}<span style="font-size:10px;color:#333;">A</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="mx-auto text-center" color="red lighten-2" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:#333;">
                          Min
                        </div>
                        <div style="font-size:12.5px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12.5px;color:#333;" v-else>{{ Math.min(...amp1) }}<span style="font-size:10px;color:#333;">A</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div class="mt-4">
                <p class="mx-auto text-center" style="font-size:11px;  padding:0; margin:0;">P<span style="font-size:8px">F</span></p>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="white" dark>
                      <v-card-text>
                        <div style="color:black;font-size:10px;color:#333;">
                          Recently
                        </div>
                        <div style="color:black;font-size:12px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="color:black;font-size:12px;color:#333;" v-else>
                          {{ pf1[0] }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="white" dark>
                      <v-card-text>
                        <div style="color:black;font-size:10px;color:#333;">
                          Peak
                        </div>
                        <div style="color:black;font-size:12.5px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="color:black;font-size:12.5px;color:#333;" v-else>
                          {{ Math.max(...pf1) }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="mx-auto text-center" color="white" dark>
                      <v-card-text>
                        <div style="color:black;font-size:10px;color:#333;">
                          Min
                        </div>
                        <div style="color:black;font-size:12.5px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="color:black;font-size:12.5px;color:#333;" v-else>
                          {{ Math.min(...pf1) }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div class="mt-4">
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="white" dark>
                      <v-card-text>
                        <div style="color:black;font-size:10px;color:#333;">
                          Swell occurrence
                        </div>
                        <div style="color:black;font-size:12px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="color:black;font-size:12px;color:#333;" v-else>
                          {{ event1.length }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="mx-auto text-center" color="white" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:#333;">
                          Sag occurrence
                        </div>
                        <div style="color:black;font-size:12px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12px;color:#333;" v-else>
                          {{ event2.length }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-card>
        </div>
      </div>
    </v-container>

    <v-container>
      <div v-if="loading">
        <v-container style="height: 200px;">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="text-subtitle-1 text-center" cols="12">
              <span style="font-size:12px">Getting your chart</span>
            </v-col>
            <v-col cols="6">
              <v-progress-linear color="blue" indeterminate rounded height="6"></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <div v-else>
        <div v-if="board.length == 0">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="text-subtitle-1 text-center" cols="12">
              No Data
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <v-card class="pa-1 pt-5 pb-10">
            <h4 class="mx-auto text-center mb-5" style="color:grey;">Phase 2</h4>
            <apexchart type="line" :options="voltageP2ChartMobile" :series="voltageP2Series"></apexchart>

            <div class="mt-3 pa-1">
              <div>
                <p class="mx-auto text-center" style="font-size:11px; padding:0; margin:0">Phase-2</p>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="yellow">
                      <v-card-text>
                        <div style="font-size:10px;color:#333;">
                          From Beginning
                        </div>
                        <div style="font-size:12px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12px;color:#333;" v-else>{{ kw2[0].toFixed(0) }}<span style="font-size:10px">kW</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="mx-auto text-center" color="yellow" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:#333;">
                          Query Period Total:
                        </div>
                        <div style="font-size:12px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12px;color:#333;" v-else>{{ Math.abs(kw2[0] - kw2.slice(-1)[0]).toFixed(2) }}<span style="font-size:10px;color:#333;">kW</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div class="mt-4">
                <p class="mx-auto text-center" style="font-size:11px; padding:0; margin:0">Voltage</p>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="yellow" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:#333;">
                          Recently
                        </div>
                        <div style="font-size:12px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12px;color:#333;" v-else>{{ volt2[0].toFixed(2) }}<span style="font-size:10px">V</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="yellow" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:#333;">
                          Peak
                        </div>
                        <div style="font-size:12.5px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12.5px;color:#333;" v-else>{{ Math.max(...volt2) }}<span style="font-size:10px;color:#333;">V</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="mx-auto text-center" color="yellow lighten-3" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:#333;">
                          Min
                        </div>
                        <div style="font-size:12.5px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12.5px;color:#333;" v-else>{{ Math.min(...volt2) }}<span style="font-size:10px;color:#333;">V</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div class="mt-4">
                <p class="mx-auto text-center" style="font-size:11px; padding:0; margin:0">Current</p>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="yellow" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:#333;">
                          Recently
                        </div>
                        <div style="font-size:12p;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12px;color:#333;" v-else>{{ amp2[0] }}<span style="font-size:10px;color:#333;">A</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="yellow" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:#333;">
                          Peak
                        </div>
                        <div style="font-size:12.5px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12.5px;color:#333;" v-else>{{ Math.max(...amp2) }}<span style="font-size:10px;color:#333;">A</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="mx-auto text-center" color="yellow lighten-3" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:#333;">
                          Min
                        </div>
                        <div style="font-size:12.5px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12.5pxl;color:#333;" v-else>{{ Math.min(...amp2) }}<span style="font-size:10px;color:#333;">A</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div class="mt-4">
                <p class="mx-auto text-center" style="font-size:11px;  padding:0; margin:0;">P<span style="font-size:8px">F</span></p>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="white" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:#333;">
                          Recently
                        </div>
                        <div style="font-size:12px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12px;color:#333;" v-else>
                          {{ pf2[0] }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="white" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:#333;">
                          Peak
                        </div>
                        <div style="font-size:12.5px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12.5px;color:#333;" v-else>
                          {{ Math.max(...pf2) }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="mx-auto text-center" color="white" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:#333;">
                          Min
                        </div>
                        <div style="font-size:12.5px;color:#333;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12.5px;color:#333;" v-else>
                          {{ Math.min(...pf2) }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div class="mt-4">
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="white" dark>
                      <v-card-text>
                        <div style="color:black;font-size:10px">
                          Swell occurrence
                        </div>
                        <div style="color:black;font-size:12px" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="color:black;font-size:12px" v-else>
                          {{ event3.length }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="mx-auto text-center" color="white" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:black;">
                          Sag occurrence
                        </div>
                        <div style="color:black;font-size:12px" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12px;color:black;" v-else>
                          {{ event4.length }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-card>
        </div>
      </div>
    </v-container>

    <v-container>
      <div v-if="loading">
        <v-container style="height: 200px;">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="text-subtitle-1 text-center" cols="12">
              <span style="font-size:12px">Getting your chart</span>
            </v-col>
            <v-col cols="6">
              <v-progress-linear color="blue" indeterminate rounded height="6"></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <div v-else>
        <div v-if="board.length == 0">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="text-subtitle-1 text-center" cols="12">
              No Data
            </v-col>
          </v-row>
        </div>

        <div v-else>
          <v-card class="pt-5 pb-10">
            <h4 class="mx-auto text-center mb-5" style="color:grey;">Phase 3</h4>
            <apexchart type="line" :options="voltageP3ChartMobile" :series="voltageP3Series"></apexchart>

            <div class="mt-3 pa-1">
              <div>
                <p class="mx-auto text-center" style="font-size:11px; padding:0; margin:0">Phase-3</p>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="blue">
                      <v-card-text>
                        <div style="font-size:10px; color:black;">
                          From Beginning
                        </div>
                        <div style="font-size:12px;color:black;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12px;color:black;" v-else>{{ kw3[0].toFixed(0) }}<span style="font-size:10px">kW</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="mx-auto text-center" color="blue" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:black;">
                          Query Period Total:
                        </div>
                        <div style="font-size:12px;color:black;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12px;color:black;" v-else>{{ Math.abs(kw3[0] - kw2.slice(-1)[0]).toFixed(2) }}<span style="font-size:10px">kW</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div class="mt-4">
                <p class="mx-auto text-center" style="font-size:11px; padding:0; margin:0">Voltage</p>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="blue" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:black;">
                          Recently
                        </div>
                        <div style="font-size:12px;color:black;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12px;color:black;" v-else>{{ volt3[0].toFixed(2) }}<span style="font-size:10px">V</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="blue" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:black;">
                          Peak
                        </div>
                        <div style="font-size:12.5px;color:black;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12.5px;color:black;" v-else>{{ Math.max(...volt3) }}<span style="font-size:10px">V</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="mx-auto text-center" color="blue lighten-3" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:black;">
                          Min
                        </div>
                        <div style="font-size:12.5px;color:black;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12.5px;color:black;" v-else>{{ Math.min(...volt3) }}<span style="font-size:10px">V</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div class="mt-4">
                <p class="mx-auto text-center" style="font-size:11px; padding:0; margin:0">Current</p>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="blue" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:black;">
                          Recently
                        </div>
                        <div style="font-size:12p;color:black;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12px;color:black;" v-else>{{ amp3[0] }}<span style="font-size:10px">A</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="blue" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:black;">
                          Peak
                        </div>
                        <div style="font-size:12.5px;color:black;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12.5px;color:black;" v-else>{{ Math.max(...amp3) }}<span style="font-size:10px">A</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="mx-auto text-center" color="blue lighten-3" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:black;">
                          Min
                        </div>
                        <div style="font-size:12.5px;color:black;" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12.5pxl;color:black;" v-else>{{ Math.min(...amp3) }}<span style="font-size:10px">A</span></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div class="mt-4">
                <p class="mx-auto text-center" style="font-size:11px;  padding:0; margin:0;">P<span style="font-size:8px">F</span></p>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="white" dark>
                      <v-card-text>
                        <div style="color:black;font-size:10px">
                          Recently
                        </div>
                        <div style="color:black;font-size:12px" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="color:black;font-size:12px" v-else>
                          {{ pf3[0] }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="white" dark>
                      <v-card-text>
                        <div style="color:black;font-size:10px">
                          Peak
                        </div>
                        <div style="color:black;font-size:12.5px" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="color:black;font-size:12.5px" v-else>
                          {{ Math.max(...pf3) }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="mx-auto text-center" color="white" dark>
                      <v-card-text>
                        <div style="color:black;font-size:10px">
                          Min
                        </div>
                        <div style="color:black;font-size:12.5px" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="color:black;font-size:12.5px" v-else>
                          {{ Math.min(...pf3) }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div class="mt-4">
                <v-row>
                  <v-col>
                    <v-card class="mx-auto text-center" color="white" dark>
                      <v-card-text>
                        <div style="color:black;font-size:10px">
                          Swell occurrence
                        </div>
                        <div style="color:black;font-size:12px" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="color:black;font-size:12px" v-else>
                          {{ event5.length }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="mx-auto text-center" color="white" dark>
                      <v-card-text>
                        <div style="font-size:10px;color:black;">
                          Sag occurrence
                        </div>
                        <div style="color:black;font-size:12px" v-if="board.length == 0">
                          No Data
                        </div>
                        <div style="font-size:12px;color:black;" v-else>
                          {{ event6.length }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-card>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
  import Vue from "vue";
  import axios from "axios";
  import moment from "moment";
  import VueApexCharts from "vue-apexcharts";

  Vue.component("apexchart", VueApexCharts);

  export default {
    data: () => ({
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Energy",
          disabled: true,
          href: "",
        },
        {
          text: "Usage By Phase",
          disabled: true,
          href: "",
        },
      ],
      // values1: moment().subtract(24, "hour"),
      // values2: moment(),
      presets: [
        {
          label: "Last 1 Hour",
          range: [moment().subtract(1, "hour"), moment()],
        },
        {
          label: "Last 3 Hour",
          range: [moment().subtract(3, "hour"), moment()],
        },
        {
          label: "Last 12 Hour",
          range: [moment().subtract(12, "hour"), moment()],
        },
        {
          label: "Today",
          range: [moment().startOf("day"), moment().endOf("day")],
        },
        {
          label: "This Week",
          range: [
            moment()
              .clone()
              .startOf("week"),
            moment()
              .clone()
              .endOf("week"),
          ],
        },
        {
          label: "Last Week",
          range: [
            moment()
              .subtract(1, "weeks")
              .startOf("week"),
            moment()
              .subtract(1, "weeks")
              .endOf("week"),
          ],
        },
        {
          label: "This Month",
          range: [moment().startOf("month"), moment().endOf("month")],
        },
        {
          label: "Last Month",
          range: [moment().subtract(2, "month"), moment().subtract(1, "month")],
        },
      ],
      isMobile: true,
      loading: true,
      loading5: false,
      timer: true,
      loader: null,
      meter: [],
      board: [],
      boardName: [],
      boardItem: [],
      event1: [],
      event2: [],
      event3: [],
      event4: [],
      event5: [],
      event6: [],
      kw1: [],
      kw2: [],
      kw3: [],
      volt1: [],
      volt2: [],
      volt3: [],
      amp1: [],
      amp2: [],
      amp3: [],
      totalPhase: [],

      voltageP1Chart: {
        chart: {
          width: "100%",
          type: "line",
          animations: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
          },
        },
        yaxis: [
          {
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: "#FF1654",
            },
            labels: {
              style: {
                colors: "#FF1654",
              },
              formatter: (val) => {
                return val + "V";
              },
            },
            title: {
              text: "Voltage",
              style: {
                color: "#FF1654",
              },
            },
          },
          {
            opposite: true,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: "#0096FF",
            },
            labels: {
              style: {
                colors: "#0096FF",
              },
              formatter: (val) => {
                return val + "A";
              },
            },
            title: {
              text: "Current",
              style: {
                color: "#0096FF",
              },
            },
          },
        ],
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 2,
          dashArray: 0,
        },
        colors: ["#FF1654", "#0096FF"],
        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          position: "top",
        },
      },

      voltageP1ChartMobile: {
        chart: {
          width: "100%",
          type: "line",
          animations: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
          },
        },
        yaxis: [
          {
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: "#FF1654",
            },
            labels: {
              style: {
                colors: "#FF1654",
              },
              formatter: (val) => {
                return val + "V";
              },
            },
            title: {
              text: "Voltage",
              style: {
                color: "#FF1654",
              },
            },
          },
          {
            opposite: true,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: "#0096FF",
            },
            labels: {
              style: {
                colors: "#0096FF",
              },
              formatter: (val) => {
                return val + "A";
              },
            },
            title: {
              text: "Current",
              style: {
                color: "#0096FF",
              },
            },
          },
        ],
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 2,
          dashArray: 0,
        },
        colors: ["#FF1654", "#0096FF"],
        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
        },
        legend: {
          show: false,
          showForSingleSeries: true,
          position: "top",
        },
      },

      voltageP1Series: [
        {
          data: [],
        },
      ],
      voltageP2Chart: {
        chart: {
          width: "100%",
          type: "line",
          animations: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
          },
        },
        yaxis: [
          {
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: "#FF1654",
            },
            labels: {
              style: {
                colors: "#FF1654",
              },
              formatter: (val) => {
                return val + "V";
              },
            },
            title: {
              text: "Voltage",
              style: {
                color: "#FF1654",
              },
            },
          },
          {
            opposite: true,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: "#0096FF",
            },
            labels: {
              style: {
                colors: "#0096FF",
              },
              formatter: (val) => {
                return val + "A";
              },
            },
            title: {
              text: "Current",
              style: {
                color: "#0096FF",
              },
            },
          },
        ],
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 2,
          dashArray: 0,
        },
        colors: ["#FF1654", "#0096FF"],
        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          position: "top",
        },
      },

      voltageP2ChartMobile: {
        chart: {
          width: "100%",
          type: "line",
          animations: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
          },
        },
        yaxis: [
          {
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: "#FF1654",
            },
            labels: {
              style: {
                colors: "#FF1654",
              },
              formatter: (val) => {
                return val + "V";
              },
            },
            title: {
              text: "Voltage",
              style: {
                color: "#FF1654",
              },
            },
          },
          {
            opposite: true,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: "#0096FF",
            },
            labels: {
              style: {
                colors: "#0096FF",
              },
              formatter: (val) => {
                return val + "A";
              },
            },
            title: {
              text: "Current",
              style: {
                color: "#0096FF",
              },
            },
          },
        ],
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 2,
          dashArray: 0,
        },
        colors: ["#FF1654", "#0096FF"],
        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
        },
        legend: {
          show: false,
          showForSingleSeries: true,
          position: "top",
        },
      },

      voltageP2Series: [
        {
          data: [],
        },
      ],
      voltageP3Chart: {
        chart: {
          width: "100%",
          type: "line",
          animations: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
          },
        },
        yaxis: [
          {
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: "#FF1654",
            },
            labels: {
              style: {
                colors: "#FF1654",
              },
              formatter: (val) => {
                return val + "V";
              },
            },
            title: {
              text: "Voltage",
              style: {
                color: "#FF1654",
              },
            },
          },
          {
            opposite: true,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: "#0096FF",
            },
            labels: {
              style: {
                colors: "#0096FF",
              },
              formatter: (val) => {
                return val + "A";
              },
            },
            title: {
              text: "Current",
              style: {
                color: "#0096FF",
              },
            },
          },
        ],
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 2,
          dashArray: 0,
        },
        colors: ["#FF1654", "#0096FF"],
        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          position: "top",
        },
      },

      voltageP3ChartMobile: {
        chart: {
          width: "100%",
          type: "line",
          animations: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
          },
        },
        yaxis: [
          {
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: "#FF1654",
            },
            labels: {
              style: {
                colors: "#FF1654",
              },
              formatter: (val) => {
                return val + "V";
              },
            },
            title: {
              text: "Voltage",
              style: {
                color: "#FF1654",
              },
            },
          },
          {
            opposite: true,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: "#0096FF",
            },
            labels: {
              style: {
                colors: "#0096FF",
              },
              formatter: (val) => {
                return val + "A";
              },
            },
            title: {
              text: "Current",
              style: {
                color: "#0096FF",
              },
            },
          },
        ],
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 2,
          dashArray: 0,
        },
        colors: ["#FF1654", "#0096FF"],
        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
        },
        legend: {
          show: false,
          showForSingleSeries: true,
          position: "top",
        },
      },
      voltageP3Series: [
        {
          data: [],
        },
      ],
    }),
    mounted() {
      this.loadsBoard();
      this.loadsBoardName();
      this.loadsMeter();
      this.onResize();
      window.addEventListener("resize", this.onResize, { passive: true });
    },
    computed: {
      totalNeedPay() {
        var kw1 = this.board.map((kw) => kw.fields.p_phase1);
        var kw2 = this.board.map((kw) => kw.fields.p_phase2);
        var kw3 = this.board.map((kw) => kw.fields.p_phase3);
        var totalKw1 = Math.abs(kw1.slice(-1)[0] - kw1.slice(1)[0]);
        var totalKw2 = Math.abs(kw2.slice(-1)[0] - kw2.slice(1)[0]);
        var totalKw3 = Math.abs(kw3.slice(-1)[0] - kw3.slice(1)[0]);
        var totalAllKw = totalKw1 + totalKw2 + totalKw3;
        switch (totalAllKw) {
          case totalAllKw > 900:
            return (200 * 0.218 + 100 * 0.334 + 300 * 0.516 + 300 * 0.546 + (totalAllKw - 900) * 0.571).toFixed(2);
          case totalAllKw > 600:
            return (200 * 0.218 + 100 * 0.334 + 300 * 0.516 + (totalAllKw - 600) * 0.546).toFixed(2);
          case totalAllKw > 300:
            return (200 * 0.218 + 100 * 0.334 + (totalAllKw - 300) * 0.516).toFixed(2);
          case totalAllKw > 200:
            return (200 * 0.218 + (totalAllKw - 200) * 0.334).toFixed(2);
          default:
            return (totalAllKw * 0.218).toFixed(2);
        }
      },
      totalPhase1() {
        var kw1 = this.board.map((kw) => kw.fields.p_phase1);
        var totalKw1 = Math.abs(kw1.slice(-1)[0] - kw1.slice(1)[0]);
        switch (totalKw1) {
          case totalKw1 > 900:
            return (200 * 0.218 + 100 * 0.334 + 300 * 0.516 + 300 * 0.546 + (totalKw1 - 900) * 0.571).toFixed(2);
          case totalKw1 > 600:
            return (200 * 0.218 + 100 * 0.334 + 300 * 0.516 + (totalKw1 - 600) * 0.546).toFixed(2);
          case totalKw1 > 300:
            return (200 * 0.218 + 100 * 0.334 + (totalKw1 - 300) * 0.516).toFixed(2);
          case totalKw1 > 200:
            return (200 * 0.218 + (totalKw1 - 200) * 0.334).toFixed(2);
          default:
            return (totalKw1 * 0.218).toFixed(2);
        }
      },
      totalPhase2() {
        var kw2 = this.board.map((kw) => kw.fields.p_phase2);
        var totalKw2 = Math.abs(kw2.slice(-1)[0] - kw2.slice(1)[0]);
        switch (totalKw2) {
          case totalKw2 > 900:
            return (200 * 0.218 + 100 * 0.334 + 300 * 0.516 + 300 * 0.546 + (totalKw2 - 900) * 0.571).toFixed(2);
          case totalKw2 > 600:
            return (200 * 0.218 + 100 * 0.334 + 300 * 0.516 + (totalKw2 - 600) * 0.546).toFixed(2);
          case totalKw2 > 300:
            return (200 * 0.218 + 100 * 0.334 + (totalKw2 - 300) * 0.516).toFixed(2);
          case totalKw2 > 200:
            return (200 * 0.218 + (totalKw2 - 200) * 0.334).toFixed(2);
          default:
            return (totalKw2 * 0.218).toFixed(2);
        }
      },
      totalPhase3() {
        var kw3 = this.board.map((kw) => kw.fields.p_phase3);
        var totalKw3 = Math.abs(kw3.slice(-1)[0] - kw3.slice(1)[0]);
        switch (totalKw3) {
          case totalKw3 > 900:
            return (200 * 0.218 + 100 * 0.334 + 300 * 0.516 + 300 * 0.546 + (totalKw3 - 900) * 0.571).toFixed(2);
          case totalKw3 > 600:
            return (200 * 0.218 + 100 * 0.334 + 300 * 0.516 + (totalKw3 - 600) * 0.546).toFixed(2);
          case totalKw3 > 300:
            return (200 * 0.218 + 100 * 0.334 + (totalKw3 - 300) * 0.516).toFixed(2);
          case totalKw3 > 200:
            return (200 * 0.218 + (totalKw3 - 200) * 0.334).toFixed(2);
          default:
            return (totalKw3 * 0.218).toFixed(2);
        }
      },
      totalMeter() {
        var meter = this.meter.map((mtr) => mtr.meter);
        var lastMeter = meter[0];
        var bindMeter = this.meter.map((kwh) => kwh.kwh);
        var lastBindMeter = bindMeter[0];
        var start = this.meter.map((ts) => ts.updatedAt);
        var startDate = moment(start[0]).unix();
        var endDate = moment(this.$store.state.dateTime1).unix();
        var kwh = this.board.map((kw) => kw.fields.totalPhase);
        var totalKwh = Math.abs(kwh[0] - lastBindMeter);

        if (endDate > startDate) {
          return (totalKwh + lastMeter).toFixed(0);
        } else {
          return "Try difference date";
        }
      },
      lastUpdate() {
        var start = this.board.map((ts) => ts.timestamp);
        var startDate = moment(start[0]).format("D MMM YYYY, h:mm:ss a");
        var endDate = moment();
        var duration = endDate.from(startDate);

        return duration;
      },
      lastOnline() {
        var start = this.board.map((ts) => ts.timestamp);
        var startDate = moment(start[0]).format("D MMM YYYY, h:mm:ss a");
        var endDate = moment();
        var duration = endDate.diff(startDate, "minutes");

        return duration;
      },
    },
    methods: {
      intervalFetchData: function() {
        setInterval(() => {
          if (this.timer == true) {
            this.loadsCo2(), this.loadsWeather();
          }
        }, 300000);
      },
      onResize() {
        this.isMobile = window.innerWidth < 700;
      },
      unixConvert(value) {
        return moment(value).unix();
      },
      formatDate(value) {
        return moment(value).format("D MMM YYYY, h:mm:ss a");
      },
      loadsBoardName: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/single-phase";
        axios
          .get(apiURL)
          .then((res) => {
            this.boardName = res.data;
            this.boardItem = this.boardName[1].boardName;
            this.loadsBoard();
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsEvent1: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/cms/" + this.boardItem + "/" + this.$store.state.dateTime1.toDate() + "/" + this.$store.state.dateTime.toDate() + "/" + 1;
        axios
          .get(apiURL)
          .then((res) => {
            this.event1 = res.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsEvent2: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/cms/" + this.boardItem + "/" + this.$store.state.dateTime1.toDate() + "/" + this.$store.state.dateTime2.toDate() + "/" + 2;
        axios
          .get(apiURL)
          .then((res) => {
            this.event2 = res.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsEvent3: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/cms/" + this.boardItem + "/" + this.$store.state.dateTime1.toDate() + "/" + this.$store.state.dateTime2.toDate() + "/" + 3;
        axios
          .get(apiURL)
          .then((res) => {
            this.event3 = res.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsEvent4: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/cms/" + this.boardItem + "/" + this.$store.state.dateTime1.toDate() + "/" + this.$store.state.dateTime2.toDate() + "/" + 4;
        axios
          .get(apiURL)
          .then((res) => {
            this.event4 = res.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsEvent5: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/cms/" + this.boardItem + "/" + this.$store.state.dateTime1.toDate() + "/" + this.$store.state.dateTime2.toDate() + "/" + 5;
        axios
          .get(apiURL)
          .then((res) => {
            this.event5 = res.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsEvent6: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/cms/" + this.boardItem + "/" + this.$store.state.dateTime1.toDate() + "/" + this.$store.state.dateTime2.toDate() + "/" + 6;
        axios
          .get(apiURL)
          .then((res) => {
            this.event6 = res.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsMeter: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/meter";
        axios
          .get(apiURL)
          .then((res) => {
            this.meter = res.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsBoard: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/cms/" + this.boardItem + "/" + this.$store.state.dateTime1.toDate() + "/" + this.$store.state.dateTime2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.board = res.data;
            this.kw1 = res.data.map((kw) => kw.fields.p_phase1);
            this.kw2 = res.data.map((kw) => kw.fields.p_phase2);
            this.kw3 = res.data.map((kw) => kw.fields.p_phase3);

            this.volt1 = res.data.map((v) => v.fields.v_phase1);
            this.volt2 = res.data.map((v) => v.fields.v_phase2);
            this.volt3 = res.data.map((v) => v.fields.v_phase3);

            this.amp1 = res.data.map((a) => a.fields.i_phase1);
            this.amp2 = res.data.map((a) => a.fields.i_phase2);
            this.amp3 = res.data.map((a) => a.fields.i_phase3);

            this.pf1 = res.data.map((pf) => pf.fields.pf1);
            this.pf2 = res.data.map((pf) => pf.fields.pf2);
            this.pf3 = res.data.map((pf) => pf.fields.pf3);

            this.totalPhase = res.data.map((total) => total.fields.totalPhase);

            let voltageP1 = this.board.map((e) => {
              return {
                x: e.timestamp,
                y: e.fields.v_phase1,
              };
            });

            let currentP1 = this.board.map((e) => {
              return {
                x: e.timestamp,
                y: e.fields.i_phase1,
              };
            });

            this.voltageP1Series = [
              {
                name: "Voltage",
                data: voltageP1,
              },
              {
                name: "Current",
                data: currentP1,
              },
            ];

            let voltageP2 = this.board.map((e) => {
              return {
                x: e.timestamp,
                y: e.fields.v_phase2,
              };
            });

            let currentP2 = this.board.map((e) => {
              return {
                x: e.timestamp,
                y: e.fields.i_phase2,
              };
            });

            this.voltageP2Series = [
              {
                name: "Voltage",
                data: voltageP2,
              },
              {
                name: "Current",
                data: currentP2,
              },
            ];

            let voltageP3 = this.board.map((e) => {
              return {
                x: e.timestamp,
                y: e.fields.v_phase3,
              };
            });

            let currentP3 = this.board.map((e) => {
              return {
                x: e.timestamp,
                y: e.fields.i_phase3,
              };
            });

            this.voltageP3Series = [
              {
                name: "Voltage",
                data: voltageP3,
              },
              {
                name: "Current",
                data: currentP3,
              },
            ];
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (this.loading = false));
      },
      updateData(values) {
        this.values1 = values[0];
        this.values2 = values[1];
        this.$store.commit("setDateTime1", this.values1);
        this.$store.commit("setDateTime2", this.values2);
        this.loadsBoard();
        this.loadsEvent1();
        this.loadsEvent2();
        this.loadsEvent3();
        this.loadsEvent4();
        this.loadsEvent5();
        this.loadsEvent6();
        this.loadsMeter();
        this.loading = true;
      },
      updateBoard() {
        this.loadsBoard();
        this.loadsEvent1();
        this.loadsEvent2();
        this.loadsEvent3();
        this.loadsEvent4();
        this.loadsEvent5();
        this.loadsEvent6();
        this.loadsMeter();
        this.loading = true;
      },
    },
    beforeDestroy() {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", this.onResize, { passive: true });
      }
    },
    watch: {
      loader() {
        const l = this.loader;
        this[l] = !this[l];

        setTimeout(() => (this[l] = false), 500);

        this.loader = null;
      },
    },
  };
</script>

<style scoped>
  .wrapper {
    position: relative;
  }
</style>
